import React from 'react';

export type LoadingVariant = 'inline' | 'panel' | 'page';

export interface LoadingStatusProps {
  label: string;
  ariaLabel?: string;
  description?: string;
  variant?: LoadingVariant;
  className?: string;
}

const variantClasses: Record<LoadingVariant, string> = {
  inline: 'inline-flex items-center gap-2',
  panel: 'flex items-center justify-center gap-3 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-gray-900',
  page: 'flex min-h-screen items-center justify-center gap-3',
};

export const LoadingSpinner: React.FC<{className?: string}> = ({className = 'h-5 w-5 text-primary-600'}) => (
  <svg
    className={`${className} shrink-0 animate-spin motion-reduce:animate-none`}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

const LoadingStatus: React.FC<LoadingStatusProps> = ({
  label,
  ariaLabel,
  description,
  variant = 'inline',
  className = '',
}) => (
  <div
    role="status"
    aria-label={ariaLabel ?? label}
    aria-live="polite"
    className={`${variantClasses[variant]} text-sm text-gray-600 dark:text-gray-300 ${className}`}
  >
    <LoadingSpinner />
    <div>
      <div className="font-medium text-gray-900 dark:text-gray-100">{label}</div>
      {description && <div className="mt-0.5 text-gray-500 dark:text-gray-400">{description}</div>}
    </div>
  </div>
);

export default LoadingStatus;
